import cloneDeep from 'lodash/cloneDeep';
import store from '@/store/store';
import { CATEGORIE_DIVERS } from '@/configuration/produitConf';
import { NORMAL } from '@/configuration/devisConf';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';

export function isLigneHonoraireForfaitaire(ligne, produit) {
  return ligne.type === NORMAL
    && ligne.typeProduit === CATEGORIE_DIVERS
    && ligne.produitId === produit.id;
}

function getLigneHonoraireForfaitaire(lignesCommande, montant, produit) {
  if (!montant) return null;
  let ligne = lignesCommande.find(lc => isLigneHonoraireForfaitaire(lc, produit));
  if (ligne) {
    ligne.prixUnitaire = montant;
    ligne.totalHt = montant * ligne.quantite;
  } else {
    if (!produit) return null;
    const ordre = lignesCommande.length > 0
      ? Math.max(...lignesCommande.map(lc => lc.ordre)) / 100
      : 0;
    ligne = genererLigneCommande(ordre + 1);
    miseAJourArticle(ligne);
    ligne.libelle = produit.libelle;
    ligne.prixUnitaire = montant;
    ligne.totalHt = montant * ligne.quantite;
    ligne.produit = produit;
    ligne.produitId = produit.id;
    ligne.typeProduit = produit.supportCommercial.categorieVente;
    ligne.lignesRemise = [];
    ligne.type = NORMAL;
  }
  return ligne;
}

export default function genererLigneCommandeHonoraireForfaitaire(devis, montant) {
  const societe = store.getters['societe/societeActive'];
  const produit = societe.produitHonoraireForfaitaire;
  let lignesCommande = cloneDeep(devis.lignesCommande);
  lignesCommande = lignesCommande.filter(l => !isLigneHonoraireForfaitaire(l, produit));
  const ligneForfaitaire = getLigneHonoraireForfaitaire(lignesCommande, montant, produit);
  if (ligneForfaitaire) lignesCommande.push(ligneForfaitaire);
  return lignesCommande;
}
